import React, { Component } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

class JobNotes extends Component {
  constructor(props) {
    super();
    this.state = {
      notes: props.notes.slice(0, 3),
    };
  }

  viewAllJobNotes = () => {
    this.setState({
      notes: this.props.notes,
    });
  };

  render() {
    return (
      <div className="w-100 jobNotes">
        <h2 className="w-100 f4 f3-ns mb3 fw4">Job Notes</h2>
        <div className="w-100 gcc-box-1 mb4">
          {this.state.notes.map((note, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="ph3 f6 bb b--mid-gray">
              <dl className="lh-title flex w-100  flex-wrap ">
                <dt data-type="label-value" className="w-100 pv2">
                  <div className="flex flex-wrap justify-between-ns flex-column-reverse flex-row-ns">
                    <div className="near-black b w-100 w-50-ns">{note.author} ({note.authorRole})</div>
                    <div className="dark-gray w-100 w-50-ns tr-ns mb1 mb0-ns">
                      {format(note.date, 'MMMM DD, YYYY')}
                    </div>
                  </div>
                </dt>
                <dd className="near-black w-100 pb2">{note.content}</dd>
              </dl>
            </div>
          ))}
          {this.state.notes.length < this.props.notes.length &&
            <div className="ph3 pv2 f6 bb b--mid-gray">
              <a role="button" tabIndex="0" onClick={this.viewAllJobNotes}>View All Job Notes</a>
            </div>
          }
        </div>
      </div>
    );
  }
}

JobNotes.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.shape({
    author: PropTypes.string.isRequired,
    authorRole: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
};

export default JobNotes;
